import { render, staticRenderFns } from "./InviteResend.vue?vue&type=template&id=dde221f0&"
import script from "./InviteResend.vue?vue&type=script&lang=js&"
export * from "./InviteResend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports